import * as React from 'react';
import Slider from '@material-ui/core/Slider';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CompanyListDataGrid from './CompanyListDataGrid';
import Input from '@material-ui/core/Input';
import Stack from '@mui/material/Stack';
import SaveIcon from '@mui/icons-material/Save';
import PreviewIcon from '@mui/icons-material/Preview';

function valuetext(value) {
  return `${value}%`;
}

function AddScreener() {

  const [ roicScore, setRoicScore ] = React.useState([0, 100]);
  const [ roeScore, setRoeScore ] = React.useState([0, 100]);
  const [ moatScore, setMoatScore ] = React.useState([0, 100]);
  const [ debtScore, setDebtScore ] = React.useState([0, 100]);
  const [ managementScore, setManagementScore ] = React.useState([0, 100]);
  const [ valueScore, setValueScore ] = React.useState([0, 100]);

  const [ epsScore, setEpsScore ] = React.useState([0, 10]);
  const [ equityScore, setEquityScore ] = React.useState([0, 10]);
  const [ cashScore, setCashScore ] = React.useState([0, 10]);
  const [ revenueScore, setRevenueScore ] = React.useState([0, 10]);

  const [ screenerName, setScreenerName ] = React.useState('');

  const [ results, setResults ] = React.useState([]);

  const [ sevenYearsOfRecordsPresent, setSevenYearsOfRecordsPresent ] = React.useState(true)

  const [screenerNameHelperText, setScreenerNameHelperText] = React.useState('');
  const [screenerNameError, setScreenerNameError] = React.useState(false);
  const [disableButton, setDisableButton] = React.useState(true);

  const [ previewButtonState, setPreviewButtonState ] = React.useState('Preview');

  const [ previewMsgDisplayClass, setPreviewMsgDisplayClass ]   = React.useState('');
  const [ previewMsg, setPreviewMsg ] = React.useState('');

  const previewRef = React.useRef(null);
  const screenerRef = React.useRef(null);

  const handleRoicChange = (event, newValue) => {
    setRoicScore(newValue);
    setDisableButton(false);
  };

  const handleRoeChange = (event, newValue) => {
    setRoeScore(newValue);
    setDisableButton(false);
  };

  const handleMoatChange = (event, newValue) => {
    setMoatScore(newValue);
    setDisableButton(false);
  };

  const handleDebtChange = (event, newValue) => {
    setDebtScore(newValue);
    setDisableButton(false);
  };

  const handleManagementChange = (event, newValue) => {
    setManagementScore(newValue);
    setDisableButton(false);
  };

  const handleEquityChange = (event, newValue) => {
    setEquityScore(newValue);
    setDisableButton(false);
  };

  const handleEpsChange = (event, newValue) => {
    setEpsScore(newValue);
    setDisableButton(false);
  };

  const handleCashChange = (event, newValue) => {
    setCashScore(newValue);
    setDisableButton(false);
  };

  const handleRevenueChange = (event, newValue) => {
    setRevenueScore(newValue);
    setDisableButton(false);
  };

  const handleValueChange = (event, newValue) => {
    setValueScore(newValue);
    setDisableButton(false);
  };

  const handleNameChange = (event) => {
    setScreenerName(event.target.value);
    setScreenerNameHelperText('');
    setScreenerNameError(false);
  };

  const handleSevenYearsOfRecordsChange = (event) => {
    setSevenYearsOfRecordsPresent(event.target.checked);
  };

  const percentageMarks = [
    {
      value: 0,
      label: '0%',
    },
    {
      value: 20,
      label: '20%',
    },
    {
      value: 50,
      label: '50%',
    },
    {
      value: 80,
      label: '80%',
    },
    {
      value: 100,
      label: '100%',
    },
  ];

  const tenMarks = [
    {
      value: 0,
      label: '0',
    },
    {
      value: 2,
      label: '2',
    },
    {
      value: 5,
      label: '5',
    },
    {
      value: 8,
      label: '8',
    },
    {
      value: 10,
      label: '10',
    },
  ];

  function scrollIntoPreview() {
    previewRef.current.scrollIntoView();
  }

  function scrollIntoScreener() {
    screenerRef.current.scrollIntoView();
  }

  function screenerQueryString() {
    return "roic_start=" + roicScore[0] + "&roic_end=" + roicScore[1] +
      "roe_start=" + roeScore[0] + "&roe_end=" + roeScore[1] +
      "&moat_start=" + moatScore[0] + "&moat_end=" + moatScore[1] +
      "&debt_start=" + debtScore[0] + "&debt_end=" + debtScore[1] +
      "&management_start=" + managementScore[0] + "&management_end=" + managementScore[1] +
      "&equity_growth_rate_start=" + equityScore[0] +"&equity_growth_rate_end=" + equityScore[1] +
      "&eps_growth_rate_start=" + epsScore[0] + "&eps_growth_rate_end=" + epsScore[1] +
      "&cash_growth_rate_start=" + cashScore[0] + "&cash_growth_rate_end=" + cashScore[1] +
      "&revenue_growth_rate_start=" + revenueScore[0] + "&revenue_growth_rate_end=" + revenueScore[1] +
      "&value_start=" + valueScore[0] + "&value_end=" + valueScore[1] +
      "&seven_years_or_plus_growth_rate_present=" + (() => (sevenYearsOfRecordsPresent ? "true" : "false"))();
  }

  function createScreenerPreviewAPI() {
    const url = "/preview/screener?" + screenerQueryString();
    fetch(url)
      .then(function(response) {
        if(!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then(response => response.json())
      .then(result => completeLoading(result.data))
      .catch(function(e) {
        console.log(e)
        setPreviewMsgDisplayClass('alert alert-danger');
        setPreviewMsg('Something went wrong loading the Screener Perview. Please try again');
        setPreviewButtonState('Preview');
        setDisableButton(false);
        setResults([]);
        //scrollIntoPreview();
      })
  }

  function completeLoading(data) {
    setResults(data)
    setPreviewButtonState('Preview')
    setDisableButton(false);
    setPreviewMsgDisplayClass('alert alert-success');
    setPreviewMsg('Preview was loaded successfully');
    //scrollIntoPreview();
  }

  function generatePreview(e) {
    e.preventDefault();
    setDisableButton(true);
    setPreviewButtonState('Loading')

    createScreenerPreviewAPI()
  }

  function validateScreenerForm(e) {
    if (screenerName == '') {
      e.preventDefault()
      setScreenerNameHelperText('A name is required for the screener');
      setScreenerNameError(true);
    }
  }

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item"><a href="/profile">Profile</a></li>
            <li className="breadcrumb-item active" aria-current="page">Create Screener</li>
          </ol>
        </nav>
      </div>

      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Stock Screener</h4>
              <p className="card-description">Screen and discover wonderful businesses. Find great investment opportunities at a margin of safety.</p>
              <div className="row">
                <div className="col-lg-3">
                  <div className="py-4 border-bottom">
                    <Typography gutterBottom><strong>Value Score</strong></Typography>
                    <Slider
                      value={valueScore}
                      valueLabelDisplay="auto"
                      aria-labelledby="range-slider"
                      onChange={handleValueChange}
                      step={1}
                      marks={percentageMarks}
                      min={0}
                      max={100}
                    />
                  </div>
                  <div className="py-4 border-bottom">
                    <Typography gutterBottom><strong>ROE Score</strong></Typography>
                    <Slider
                      value={roeScore}
                      valueLabelDisplay="auto"
                      aria-labelledby="range-slider"
                      onChange={handleRoeChange}
                      step={1}
                      marks={percentageMarks}
                    />
                  </div>
                  <div className="py-4 border-bottom">
                    <Typography gutterBottom><strong>ROIC Score</strong></Typography>
                    <Slider
                      value={roicScore}
                      valueLabelDisplay="auto"
                      aria-labelledby="range-slider"
                      onChange={handleRoicChange}
                      step={1}
                      marks={percentageMarks}
                    />
                  </div>
                  <div className="py-4 border-bottom">
                    <Typography gutterBottom><strong>Management Score</strong></Typography>
                    <Slider
                      value={managementScore}
                      valueLabelDisplay="auto"
                      aria-labelledby="range-slider"
                      onChange={handleManagementChange}
                      step={1}
                      marks={percentageMarks}
                    />
                  </div>
                  <div className="py-4 border-bottom">
                    <Typography gutterBottom><strong>Debt Score</strong></Typography>
                    <Slider
                      value={debtScore}
                      valueLabelDisplay="auto"
                      aria-labelledby="range-slider"
                      onChange={handleDebtChange}
                      step={1}
                      marks={percentageMarks}
                    />
                  </div>
                  <div className="py-4 border-bottom">
                    <Typography gutterBottom><strong>Moat Score</strong></Typography>
                    <Slider
                      value={moatScore}
                      valueLabelDisplay="auto"
                      aria-labelledby="range-slider"
                      onChange={handleMoatChange}
                      step={1}
                      marks={percentageMarks}
                    />
                  </div>
                  <div className="py-4 border-bottom">
                    <form>
                      <TextField
                        onChange={handleNameChange}
                        id="outlined-basic"
                        label="Screener name"
                        variant="outlined"
                        helperText={screenerNameHelperText}
                        error={screenerNameError}
                        fullWidth
                        required
                      />
                    </form>
                  </div>
                  <div className="py-4 border-bottom">
                    <FormControlLabel control={<Checkbox defaultChecked color="primary" onChange={handleSevenYearsOfRecordsChange} />} label="7+ years of financial records available" />
                  </div>
                  <div className="py-4 border-bottom">
                    <form action="/screeners" method="POST">
                      <input type="hidden" name="name" value={screenerName} />
                      <input type="hidden" name="roic_start" value={roicScore[0]} />
                      <input type="hidden" name="roic_end" value={roicScore[1]} />

                      <input type="hidden" name="roic_start" value={roeScore[0]} />
                      <input type="hidden" name="roic_end" value={roeScore[1]} />

                      <input type="hidden" name="moat_start" value={moatScore[0]} />
                      <input type="hidden" name="moat_end" value={moatScore[1]} />

                      <input type="hidden" name="debt_start" value={debtScore[0]} />
                      <input type="hidden" name="debt_end" value={debtScore[1]} />

                      <input type="hidden" name="management_start" value={managementScore[0]} />
                      <input type="hidden" name="management_end" value={managementScore[1]} />

                      <input type="hidden" name="value_start" value={valueScore[0]} />
                      <input type="hidden" name="value_end" value={valueScore[1]} />

                      <input type="hidden" name="seven_years_or_plus_growth_rate_present" value={sevenYearsOfRecordsPresent ? "true" : "false"} />
                      <Stack direction="row" spacing={2}>
                        <Button size="small" disabled={disableButton} variant="contained" onClick={ (e) => generatePreview(e) } startIcon={<PreviewIcon />} type="submit">{previewButtonState}</Button>
                        <Button size="small" disabled={disableButton} variant="contained" onClick={ (e) => validateScreenerForm(e) } startIcon={<SaveIcon />} type="submit">Save</Button>
                      </Stack>
                    </form>
                  </div>
                </div>
                <div className="col-lg-9">
                  <div ref={previewRef} className="card">
                    <div className="card-body">
                      <h4 className="card-title">Results</h4>
                      <p className="card-description"></p>
                      <div className={ previewMsgDisplayClass } >{ previewMsg }</div>
                        <CompanyListDataGrid
                          data={results}
                        />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddScreener;
